import * as React from 'react'
import { observer } from 'mobx-react'
import { CollectionView } from '../../collections'
import { IProduct } from '../product.interfaces'
import { productStore as store } from '../product.store'
import { modalStore as modal } from '../../shared'
import { ProductDetails } from '../product-details'
import { ProductCardList, ProductCardFlex } from '.'
import './product-card.scss'
import { collectionListStore } from '../../collections/collection-list/collection-list.store'

interface IProps extends IProduct {
  view?: CollectionView
  location?: string
  narrowRow?: boolean
  displayUnavailable?: boolean
  productIsAvailable?: boolean
  hideMoreInfo?: boolean
}

const ProductCard: React.FC<IProps> = observer((props) => {
  const productIsAvailable = !!collectionListStore.originalProducts.find((product) => product.id === props.id)

  const productStatusClass = (): string => {
    if (!productIsAvailable) {
      return 'product-card--unavailable'
    } else if (!props.available) {
      return 'product-card--inactive'
    } else {
      return ''
    }
  }

  const openModal = (): void => {
    modal.set(<ProductDetails productIsAvailable={productIsAvailable} product={props} />, 'fullScreen')
    modal.toggle()
  }

  const listView = (): JSX.Element => {
    return (
      <div className={`product-card product-card--list ${productStatusClass()} col col--12of12`}>
        <ProductCardList
          openModal={openModal}
          productIsAvailable={productIsAvailable}
          {...props}
          location={props.location}
        />
      </div>
    )
  }

  const cardView = (): JSX.Element => {
    return (
      <div className={`${productStatusClass()} product-card`}>
        <ProductCardFlex openModal={openModal} productIsAvailable={productIsAvailable} {...props} />
      </div>
    )
  }

  const { view: propsView } = props
  // If the store view is overridden by props
  if (propsView) {
    return propsView === CollectionView.LIST ? listView() : cardView()
  }

  return store.collectionView === CollectionView.LIST ? listView() : cardView()
})

export { ProductCard }
